import { fromJS } from 'immutable';

import { ApiUrl2,UserToken} from '../../../helper/HelperAuth'
import { GetTemplateAll } from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (clientid,type, actionId, senderId) => async (dispatch, getState) => {
    
    if(clientid == null || clientid === undefined){
        dispatch({ type: GetTemplateAll, data: fromJS({}) });
    }
    else{
        const Authorization = UserToken;

        const url = ApiUrl2 + 'config-hsmtemplate-combo';
        
        var query = {
            "client-id": clientid,
            "sender-id":""
        };

        if(actionId===5){
            query = {
                "client-id": clientid,
                "sender-id":senderId
            };
        }
        
        var paramBody = {
            "data": query
        };
    
        const argument = {  
            method: 'POST',
            headers : {
                'Content-Type':'application/json',
                'Authorization': Authorization,
                'template-type':type
            },
            body : JSON.stringify(paramBody)
        };  
    
        const response = await doFetch(url,argument);
        var data = fromJS({});
        if(response.ok){
            data = fromJS(await response.json());
            data = data.get('Data');
        }
    
        dispatch({ type: GetTemplateAll, data: fromJS(data) });
    }
};